/* global React */
const { useState, useEffect, useRef: useRefSS } = React;

// Service names derived from the consolidated services catalog
// (content/services.js → window.DZ_SERVICES.stages).
// Edit service names there, not here.
// Each entry now carries the parent stage's slug + each service's name
// AND slug, so each pill below can render as <a href="/services/{stage}/
// {service}/"> linking to its detail page.
window.BIM_SERVICES = window.DZ_SERVICES.stages.map(s => ({
  stageSlug: s.slug,
  services:  s.services.map(svc => ({ name: svc.name, slug: svc.slug })),
}));

function StageBracket({ stageIndex, stageLabel }) {
  const stageEntry = window.BIM_SERVICES[stageIndex] || { stageSlug: '', services: [] };
  const services   = stageEntry.services;
  const stageSlug  = stageEntry.stageSlug;
  const [displayed, setDisplayed] = useState({ services, label: stageLabel, index: stageIndex, stageSlug, v: 0 });
  const vRef = useRefSS(0);

  useEffect(() => {
    vRef.current += 1;
    const id = setTimeout(() => {
      setDisplayed({ services, label: stageLabel, index: stageIndex, stageSlug, v: vRef.current });
    }, 180);
    return () => clearTimeout(id);
  }, [stageIndex, stageLabel, services, stageSlug]);

  const phaseNum = String(displayed.index + 1).padStart(2, '0');

  return (
    <aside className="dz-bracket" aria-label={`Services in ${stageLabel}`}>
      {/* Video-frame corner brackets (top-left + bottom-right) */}
      <span className="dz-bracket__corner dz-bracket__corner--tl" aria-hidden="true" />
      <span className="dz-bracket__corner dz-bracket__corner--br" aria-hidden="true" />

      <div className="dz-bracket__head">
        <div className="dz-bracket__phase" key={`p-${displayed.v}`}>
          <span className="dz-bracket__phase-num">{phaseNum}</span>
          <span className="dz-bracket__phase-name">{displayed.label}</span>
        </div>
        <div className="dz-bracket__meta">
          <span className="dz-bracket__count">{displayed.services.length}</span>
          <span>{(window.DZ_HOME && window.DZ_HOME.hero && window.DZ_HOME.hero.lifecycle && window.DZ_HOME.hero.lifecycle.servicesInPhaseLabel) || 'Services in this phase'}</span>
        </div>
      </div>

      <ul className="dz-bracket__list" key={`l-${displayed.v}`}>
        {displayed.services.map((s, i) => (
          <li key={i} className="dz-bracket__pill" style={{ animationDelay: `${i * 60}ms` }}>
            <a
              className="dz-bracket__pill-link"
              href={`${window.location.pathname.startsWith('/ar/') ? '/ar' : ''}/services/${displayed.stageSlug}/#service-${s.slug}`}
              aria-label={`Open ${s.name}`}
            >
              <span className="dz-bracket__pill-letter">{String.fromCharCode(65 + i)}</span>
              <span className="dz-bracket__pill-name">{s.name}</span>
            </a>
          </li>
        ))}
      </ul>
    </aside>
  );
}

window.StageBracket = StageBracket;
